<template>
  <div class="home">
    <!-- 轮播图 -->
    <div class="home-swipe">
      <img
        class="home-swipe-img"
        src="@/assets/images/home/home-swiper.png"
        alt=""
      />
      <div class="home-swipe-content">
        <!-- <img
          class="home-swipe-content-title"
          src="@/assets/images/home/home-swiper-tit.png"
        /> -->
        <div style="font-size: 58px; color: blue; font-weight: bold">
          北京观势空间信息科技有限公司
        </div>
        <!-- <img
          class="home-swipe-content-sub"
          src="@/assets/images/home/home-swiper-sub.png"
        /> -->
        <div class="home-swipe-content-line"></div>
        <div class="home-swipe-content-text">
          以人为本 责心向善 持续改进 管理创新
        </div>
      </div>
    </div>
    <!-- 产品范围 -->
    <div class="home-product">
      <div class="home-product-title wow bounceIn">
        <div class="home-product-title-img">
          <img
            class="home-product-title-img"
            src="@/assets/images/home/home-title1.png"
          />
          <img
            class="home-product-title-bg"
            src="@/assets/images/title-left.png"
          />
        </div>
      </div>
      <div class="home-product-content">
        <div class="home-product-content-item">
          <div class="wow bounceInLeft">
            观势科技主营业务是人工智能数据处理系统、卫星数据管理，元宇宙零工管理系统。公司也致力于为企业提供软件开发,
            网站建设, 网页设计, IT外包, 手机应用开发, 互联网营销,
            微信平台开发等解决方案。
          </div>
          <img
            class="home-product-content-item-img wow bounceInUp"
            src="@/assets/images/home/home-1.png"
          />
        </div>
        <div class="home-product-content-item item2">
          <img
            class="home-product-content-item-img2 wow bounceInUp"
            src="@/assets/images/home/home-2.png"
          />
          <div class="wow bounceInRight">
            我们的客户包括集团上市公司, 国企，央企等众多行业,
            并树立了良好的口碑, 积累了丰富的经验和成功案例.
            我们提供权威专业的互联网品牌策划, 并实施高标准的设计方案,
            创造真正意义上的品牌网站,
            为互联网品牌在互动行销领域创造最大价值而不懈努力!
          </div>
        </div>
      </div>
    </div>
    <img class="home-3" src="@/assets/images/home/home-3.png" />

    <!-- “AI+营销”数字化营销新形势 -->
    <div class="home-product2">
      <div class="home-product2-title wow bounceIn">
        <div class="home-product2-title-img">
          <img
            class="home-product2-title-img"
            src="@/assets/images/home/home-title2.png"
          />
          <img
            class="home-product2-title-bg"
            src="@/assets/images/title-left.png"
          />
        </div>
      </div>
      <div class="home-product2-content">
        <img
          class="home-product2-content-img wow bounceInUp"
          src="@/assets/images/home/home-4.png"
        />
        <div class="home-product2-content-text wow flipInX">
          在互联网时代，数据管理需求、媒体的期待、用户的诉求都有了新的变化，而技术和数据的突破，为满足新需求，解决新问题创造了条件，人工智能正在深度介入营销市场，让数字营销更高效。
          AI+将助力营销升级，实时、自动、精准的营销活动，将为客户提供更多元的服务。公司结合AI使营销活动的成本更低、效率更高。
        </div>
      </div>
    </div>

    <!-- 发展背景 -->
    <div class="home-product3">
      <img class="home-product3-bg" src="@/assets/images/content-bg.png" />
      <div class="home-product3-wrap">
        <div class="home-product3-title wow bounceIn">
          <div class="home-product3-title-img">
            <img
              class="home-product3-title-img"
              src="@/assets/images/home/home-title3.png"
            />
            <img
              class="home-product3-title-bg"
              src="@/assets/images/title-right.png"
            />
          </div>
        </div>
        <img
          class="home-product3-img wow bounceInRight"
          src="@/assets/images/home/home-5.png"
        />
      </div>
    </div>

    <div>
      <!-- ----------------------- -->

      <div class="home-product2">
        <div class="home-product2-title wow bounceIn">
          <div class="home-product2-title-img">
            <div class="tttt">资料专区</div>
            <div class="ltttt">Data Zone</div>
            <img
              class="home-product2-title-bg"
              src="@/assets/images/title-left.png"
            />
          </div>
        </div>
        <div class="home-product2-content">
          <div class="home-product2-content-text wow flipInX">
            <div class="hts" @click="downloadfile">项目综合实施方案</div>
          </div>
        </div>
      </div>

      <!-- ---------------------------- -->
    </div>

    <div class="bottomba">
      <a href="" @click="opent">京ICP备2024080644号</a>
    </div>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
export default {
  mounted() {
    this.$nextTick(() => {
      new WOW().init()
    })
  },
  methods: {
    downloadfile() {
      // let a = document.createElement('a')
      // document.body.appendChild(a)
      // a.href = '/综合项目实施方案.pdf'
      // a.download = '综合项目实施方案.pdf'
      // a.style.display = 'none'
      // a.click()
      // document.body.removeChild(a)
      window.open('/项目综合实施方案.pdf', '_blank')
    },
    opent() {
      window.open('https://beian.miit.gov.cn', '_blank')
    }
  }
}
</script>

<style lang="scss">
.hts {
  color: blue;
  cursor: pointer;
}
.tttt {
  font-size: 58px;
  font-weight: bold;
  padding-left: 300px;
}
.ltttt {
  font-size: 32px;
  font-weight: 500;
  color: #666;
  padding-left: 350px;
}
.home {
  background: #fff;
  .home-swipe {
    width: 100%;
    min-width: 1200px;
    position: relative;
    .home-swipe-img {
      width: 100%;
      object-fit: cover;
      display: block;
    }
    .home-swipe-content {
      position: absolute;
      top: 20%;
      left: 117px;
    }
    .home-swipe-content-title {
      width: 467px;
      height: 81px;
      display: block;
    }
    .home-swipe-content-sub {
      width: 617px;
      height: 78px;
      display: block;
      margin: 30px 0;
    }
    .home-swipe-content-line {
      width: 724px;
      height: 6px;
      background: #003dbd;
      margin-bottom: 30px;
    }
    .home-swipe-content-text {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 36px;
      color: #666666;
      line-height: 35px;
      letter-spacing: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
  }
  // 产品范围
  .home-product {
    padding: 120px 160px;
    .home-product-title {
      display: flex;
      justify-content: space-evenly;
      .home-product-title-img {
        width: 504px;
        height: 112px;
        display: block;
        position: relative;
        .home-product-title-bg {
          width: 226px;
          height: 228px;
          position: absolute;
          top: -66%;
          left: -180px;
        }
      }
    }
    .home-product-content {
      margin-top: 64px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .home-product-content-item {
        width: 40%;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 48px;
        letter-spacing: 6px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        .home-product-content-item-img {
          width: 100%;
          margin-top: 50px;
          object-fit: cover;
          display: block;
        }
        .home-product-content-item-img2 {
          width: 100%;
          object-fit: cover;
          display: block;
          margin-bottom: 37px;
        }
      }
      .item2 {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
    }
  }
  .home-3 {
    width: 100%;
    object-fit: cover;
    display: block;
  }
  // ai+营销
  .home-product2 {
    padding: 120px 160px;
    .home-product2-title {
      display: flex;
      justify-content: space-evenly;
      .home-product2-title-img {
        width: 1091px;
        height: 112px;
        display: block;
        position: relative;
        .home-product2-title-bg {
          width: 226px;
          height: 228px;
          position: absolute;
          top: -66%;
          left: -100px;
        }
      }
    }
    .home-product2-content {
      margin-top: 90px;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      .home-product2-content-img {
        width: 44%;
        object-fit: cover;
        display: block;
      }
      .home-product2-content-text {
        width: 40%;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 24px;
        color: #333333;
        line-height: 48px;
        letter-spacing: 6px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }

  // 发展背景
  .home-product3 {
    width: 100%;
    position: relative;
    .home-product3-bg {
      width: 100%;
      object-fit: cover;
      display: block;
    }
    .home-product3-wrap {
      padding: 120px 160px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      .home-product3-title {
        display: flex;
        justify-content: space-evenly;
        .home-product3-title-img {
          width: 831px;
          height: 112px;
          display: block;
          position: relative;
          .home-product3-title-bg {
            width: 246px;
            height: 245px;
            position: absolute;
            top: -45%;
            right: -35px;
          }
        }
      }
      .home-product3-img {
        margin-top: 60px;
        width: 100%;
        object-fit: cover;
        display: block;
      }
    }
  }
}
// 1200样式
// @media screen and (max-width: 1200px) {
//   .home-swipe-content {
//     top: 25% !important;
//     left: 117px;
//   }
//   .home-swipe-content-title {
//     width: 326px !important;
//     height: 56px !important;
//   }
//   .home-swipe-content-sub {
//     width: 431px !important;
//     height: 54px !important;
//     margin: 15px 0 !important;
//   }
//   .home-swipe-content-line {
//     width: 500px !important;
//     height: 4px !important;
//     margin-bottom: 15px !important;
//   }
//   .home-swipe-content-text {
//     font-size: 25px !important;
//     line-height: 25px !important;
//     letter-spacing: 14px !important;
//   }
//   // 产品范围
//   .home-product-title-img {
//     width: 352px !important;
//     height: 78px !important;
//     .home-product-title-bg {
//       width: 158px !important;
//       height: 160px !important;
//       left: -120px !important;
//     }
//   }

//   .home-product-content-item {
//     font-size: 15px !important;
//     line-height: 30px !important;
//     letter-spacing: 3px !important;
//   }

//   // ai+营销
//   .home-product2-title-img {
//     width: 763px !important;
//     height: 78px !important;
//     display: block;
//     position: relative;
//     .home-product2-title-bg {
//       width: 158px !important;
//       height: 160px !important;
//       top: -70% !important;
//       left: -70px !important;
//     }
//   }
//   .home-product2-content {
//     margin-top: 90px;
//     .home-product2-content-img {
//       width: 40% !important;
//     }
//     .home-product2-content-text {
//       width: 40%;
//       font-size: 16px !important;
//       line-height: 33px !important;
//       letter-spacing: 4px !important;
//     }
//   }

//   // 发展背景
//   .home-product3-title-img {
//     width: 581px !important;
//     height: 78px !important;
//     .home-product3-title-bg {
//       width: 172px !important;
//       height: 171px !important;
//     }
//   }
// }

.bottomba {
  height: 40px;
  display: flex;
  justify-content: center;
  font-size: 18px;
  align-items: center;
  color: #666;
  cursor: pointer;
}
</style>
